import { Collapse } from 'antd';
import classNames from 'classnames';
import type { ReactNode } from 'react';
import React from 'react';
import { useStore } from 'zustand';

import { inventoryStore } from '../../InventoryStore';

import './InventoryCollapseTable.scss';

const { Panel } = Collapse;

type InventoryCollapseTableProps = {
  title: string;
  children: React.ReactNode;
  className?: string;
  keyPanel: string;
  extraHeader?: ReactNode;
  collapsible?: boolean;
};

export const InventoryCollapseTable = ({
  title,
  children,
  className,
  keyPanel,
  extraHeader,
  collapsible = true,
}: InventoryCollapseTableProps) => {
  const setActiveCollapseKey = useStore(
    inventoryStore,
    (state) => state.setActiveCollapseKey
  );
  const activeCollapseKey = useStore(
    inventoryStore,
    (state) => state.activeCollapseKey
  );

  return (
    <Collapse
      defaultActiveKey={activeCollapseKey}
      className={classNames('inventory-collapse', className, [
        { 'active-panel': activeCollapseKey.includes(keyPanel) },
      ])}
      onChange={(key) => {
        setActiveCollapseKey(key);
      }}
      activeKey={activeCollapseKey}
      key={`collapse_${keyPanel}`}
    >
      <Panel
        header={<span className="title">{title}</span>}
        forceRender
        showArrow={collapsible}
        collapsible={collapsible ? undefined : 'disabled'}
        extra={extraHeader}
        key={keyPanel}
        className={classNames({
          'inventory-main-collapse-panel': className?.includes('main-collapse'),
          'non-collapsible-panel': !collapsible,
        })}
      >
        {children}
      </Panel>
    </Collapse>
  );
};
